import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, MapPin, Phone, Mail, Clock } from 'lucide-react';
import { Container } from './Container';
export function Footer() {
  return <footer className="bg-[#111827] text-gray-300 pt-16 pb-8 border-t-4 border-pts-red" data-id="element-19">
      <Container data-id="element-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-21">
          {/* Brand & Contact */}
          <div className="space-y-6" data-id="element-22">
            <img src="https://cdn.magicpatterns.com/uploads/gWFT4ncmNMgwJGpFpp5fGQ/PTS-logo-clean-black-transparent.png" alt="Primetime Sports Apparel" className="h-12 w-auto brightness-0 invert" data-id="element-23" />
            <p className="text-sm text-gray-400" data-id="element-24">
              Custom Team Uniforms Without the Ordering Stress. Factory-direct
              quality, unbeatable pricing, and dedicated support.
            </p>
            <div className="space-y-3 text-sm" data-id="element-25">
              <div className="flex items-start" data-id="element-26">
                <MapPin className="h-5 w-5 mr-3 text-pts-red flex-shrink-0 mt-0.5" data-id="element-27" />
                <span data-id="element-28">
                  9229 Southampton Place
                  <br data-id="element-29" />
                  Boca Raton, Florida 33434
                </span>
              </div>
              <div className="flex items-center" data-id="element-30">
                <Phone className="h-5 w-5 mr-3 text-pts-red flex-shrink-0" data-id="element-31" />
                <a href="tel:8882188647" className="hover:text-white transition-colors font-bold" data-id="element-32">
                  888.218.8647
                </a>
              </div>
              <div className="flex items-start" data-id="element-33">
                <Mail className="h-5 w-5 mr-3 text-pts-red flex-shrink-0 mt-0.5" data-id="element-34" />
                <div className="flex flex-col" data-id="element-35">
                  <a href="mailto:savemoney@getcustomuniforms.com" className="hover:text-white transition-colors break-all" data-id="element-36">
                    savemoney@getcustomuniforms.com
                  </a>
                  <a href="mailto:support@getcustomuniforms.com" className="hover:text-white transition-colors break-all" data-id="element-37">
                    support@getcustomuniforms.com
                  </a>
                </div>
              </div>
              <div className="flex items-start" data-id="element-38">
                <Clock className="h-5 w-5 mr-3 text-pts-red flex-shrink-0 mt-0.5" data-id="element-39" />
                <span data-id="element-40">
                  Monday – Friday
                  <br data-id="element-41" />
                  9am – 7pm EST
                </span>
              </div>
            </div>
          </div>

          {/* Sports */}
          <div data-id="element-42">
            <h4 className="text-white font-oswald font-bold text-lg tracking-wide mb-6 uppercase" data-id="element-43">
              Sports
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-44">
              <li data-id="element-45">
                <Link to="/sports/baseball" className="hover:text-pts-red transition-colors" data-id="element-46">
                  Baseball
                </Link>
              </li>
              <li data-id="element-47">
                <Link to="/sports/basketball" className="hover:text-pts-red transition-colors" data-id="element-48">
                  Basketball
                </Link>
              </li>
              <li data-id="element-49">
                <Link to="/sports/football" className="hover:text-pts-red transition-colors" data-id="element-50">
                  Football
                </Link>
              </li>
              <li data-id="element-51">
                <Link to="/sports/softball" className="hover:text-pts-red transition-colors" data-id="element-52">
                  Softball
                </Link>
              </li>
              <li data-id="element-53">
                <Link to="/sports/soccer" className="hover:text-pts-red transition-colors" data-id="element-54">
                  Soccer
                </Link>
              </li>
              <li data-id="element-55">
                <Link to="/sports/cheer" className="hover:text-pts-red transition-colors" data-id="element-56">
                  Cheer
                </Link>
              </li>
              <li data-id="element-57">
                <Link to="/sports/volleyball" className="hover:text-pts-red transition-colors" data-id="element-58">
                  Volleyball
                </Link>
              </li>
              <li data-id="element-59">
                <Link to="/sports/track-field" className="hover:text-pts-red transition-colors" data-id="element-60">
                  Track & Field
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div data-id="element-61">
            <h4 className="text-white font-oswald font-bold text-lg tracking-wide mb-6 uppercase" data-id="element-62">
              Quick Links
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-63">
              <li data-id="element-64">
                <Link to="/team-stores" className="hover:text-pts-red transition-colors" data-id="element-65">
                  Team Stores
                </Link>
              </li>
              <li data-id="element-66">
                <Link to="/process" className="hover:text-pts-red transition-colors" data-id="element-67">
                  Our Process
                </Link>
              </li>
              <li data-id="element-68">
                <Link to="/about" className="hover:text-pts-red transition-colors" data-id="element-69">
                  About Us
                </Link>
              </li>
              <li data-id="element-70">
                <Link to="/contact" className="hover:text-pts-red transition-colors" data-id="element-71">
                  Contact
                </Link>
              </li>
              <li data-id="element-72">
                <Link to="/get-started" className="hover:text-pts-red transition-colors font-bold text-white" data-id="element-73">
                  Start an Order
                </Link>
              </li>
              <li data-id="element-74">
                <Link to="/my-account" className="hover:text-pts-red transition-colors" data-id="element-75">
                  My Account
                </Link>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div data-id="element-76">
            <h4 className="text-white font-oswald font-bold text-lg tracking-wide mb-6 uppercase" data-id="element-77">
              Connect
            </h4>
            <div className="flex space-x-4 mb-8" data-id="element-78">
              <a href="#" className="bg-gray-800 p-2 rounded hover:bg-pts-red hover:text-white transition-colors" data-id="element-79">
                <Facebook className="h-5 w-5" data-id="element-80" />
              </a>
              <a href="#" className="bg-gray-800 p-2 rounded hover:bg-pts-red hover:text-white transition-colors" data-id="element-81">
                <Instagram className="h-5 w-5" data-id="element-82" />
              </a>
              <a href="#" className="bg-gray-800 p-2 rounded hover:bg-pts-red hover:text-white transition-colors" data-id="element-83">
                <Twitter className="h-5 w-5" data-id="element-84" />
              </a>
            </div>

            <div className="bg-gray-800 p-5 rounded border border-gray-700" data-id="element-85">
              <h5 className="text-white font-bold mb-2" data-id="element-86">Have a Quote?</h5>
              <p className="text-sm text-gray-400 mb-4" data-id="element-87">
                Send it to us and we'll beat it. Factory direct pricing
                guaranteed.
              </p>
              <Link to="/contact" className="inline-block border border-pts-red text-pts-red hover:bg-pts-red hover:text-white px-4 py-2 rounded text-sm font-bold transition-colors w-full text-center" data-id="element-88">
                Send Us Your Quote
              </Link>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-gray-500" data-id="element-89">
          <p data-id="element-90">
            &copy; {new Date().getFullYear()} Primetime Sports Apparel. All
            rights reserved.
          </p>
          <div className="flex space-x-4 mt-4 md:mt-0" data-id="element-91">
            <Link to="/privacy" className="hover:text-gray-300" data-id="element-92">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-gray-300" data-id="element-93">
              Terms of Service
            </Link>
            <a href="https://customuniformsupplier.com" target="_blank" rel="noopener noreferrer" className="hover:text-gray-300" data-id="element-94">
              Wholesale
            </a>
          </div>
        </div>
      </Container>
    </footer>;
}